var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 3.75H12.0078",
    stroke: "#FF6F3F",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 9H7.50781",
    stroke: "#FF6F3F",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9H15",
    stroke: "#FF6F3F",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.249H15",
    stroke: "#FF6F3F",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.24902C14.3284 5.24902 15 4.57745 15 3.74902C15 2.9206 14.3284 2.24902 13.5 2.24902C12.6716 2.24902 12 2.9206 12 3.74902C12 4.57745 12.6716 5.24902 13.5 5.24902Z",
    stroke: "#2F3567",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.499C9.82843 10.499 10.5 9.82745 10.5 8.99902C10.5 8.1706 9.82843 7.49902 9 7.49902C8.17157 7.49902 7.5 8.1706 7.5 8.99902C7.5 9.82745 8.17157 10.499 9 10.499Z",
    stroke: "#2F3567",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 15.75C5.33624 15.75 6.00781 15.0784 6.00781 14.25C6.00781 13.4216 5.33624 12.75 4.50781 12.75C3.67939 12.75 3.00781 13.4216 3.00781 14.25C3.00781 15.0784 3.67939 15.75 4.50781 15.75Z",
    stroke: "#2F3567",
    strokeWidth: 1.34635,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFilter);
export default __webpack_public_path__ + "static/media/mobile_filter.f6587d2ca778151f8edb2db27bf5b349.svg";
export { ForwardRef as ReactComponent };